"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _addScript = _interopRequireDefault(require("../../../../services/utils/addScript"));
var validators = _interopRequireWildcard(require("../../../../services/input/validators"));
var _createAccount = _interopRequireDefault(require("../../mutations/createAccount"));
var _context = _interopRequireDefault(require("../../../../services/log/context"));
var _CreateAccount = _interopRequireDefault(require("../screens/CreateAccount"));
var _password = require("../../consts/password");
var _events = require("../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ZXCVBN_URL = "https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js";
// TODO no errors in state, just in render
const defaultErrors = {
  passwordError: null
};
const submitErrors = new Map([["ACCOUNT_EXISTS", _errors.default.accountExists], ["WEAK_PASSWORD", _errors.default.weakPassword], ["INVALID_EMAIL", _errors.default.invalidEmail], ["UNKNOWN", _errors.default.general]]);
class CreateAccountWithoutContext extends React.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      ...defaultErrors,
      error: null,
      password: "",
      passwordStrength: "WEAK",
      isCreatingAccount: false,
      validateEmail: false,
      showPasswordHint: false
    });
    (0, _defineProperty2.default)(this, "handleEmailBlur", () => {
      this.setState({
        validateEmail: true
      });
    });
    (0, _defineProperty2.default)(this, "handlePasswordChange", e => {
      const {
        value
      } = e.target;
      this.setState({
        password: value
      }, this.getPasswordStrength);
    });
    (0, _defineProperty2.default)(this, "handlePasswordBlur", () => {
      this.setState({
        showPasswordHint: true
      }, this.getPasswordStrength);
    });
    (0, _defineProperty2.default)(this, "handleContinue", e => {
      e.preventDefault();
      if (this.validateInput()) {
        return;
      }
      const {
        email,
        brandId,
        onSignUpConfirmation,
        log
      } = this.props;
      const {
        password
      } = this.state;
      this.setState({
        isCreatingAccount: true,
        error: null,
        ...defaultErrors
      });
      (0, _createAccount.default)({
        brandId,
        credentials: {
          email,
          password
        }
      }).then(res => {
        this.setState({
          isCreatingAccount: false
        });
        if ("success" in res) {
          log(_events.REGISTRATION_SENT, {
            email
          });
          onSignUpConfirmation();
          return;
        }
        log(_events.LOGIN_STEP_FAILED, {
          operation: "createAccount",
          error: (res === null || res === void 0 ? void 0 : res.error) || ""
        });
        this.setSubmitError(res === null || res === void 0 ? void 0 : res.error);
      }).catch(err => {
        this.setState({
          isCreatingAccount: false
        });
        log(_events.CRITICAL_LOGIN_ERROR, {
          error: String(err),
          operation: "createAccount"
        });
        this.setSubmitError(null);
      });
    });
    (0, _defineProperty2.default)(this, "validateInput", () => {
      const {
        email
      } = this.props;
      const {
        password
      } = this.state;
      const emailError = email ? validators.email(email) : _errors.default.requiredField;
      const passwordError = password ? validators.password(password) : _errors.default.requiredField;
      this.setState({
        showPasswordHint: true,
        validateEmail: true
      });
      return emailError !== null && emailError !== void 0 ? emailError : passwordError;
    });
    (0, _defineProperty2.default)(this, "getPasswordStrength", () => {
      const {
        password
      } = this.state;
      const {
        email
      } = this.props;
      const userInput = ["skypicker", "kiwi", email];

      // Score from 0 to 4 according to zxcvbn
      const score = validators.passwordScore(password, userInput);
      const passwordStrength = _password.PASSWORD_SCORE_TO_STRENGTH[String(score)];
      this.setState({
        passwordStrength: passwordStrength || "WEAK"
      });
    });
    (0, _defineProperty2.default)(this, "setSubmitError", responseError => {
      const error = responseError ? submitErrors.get(responseError) : null;
      this.setState({
        error: error !== null && error !== void 0 ? error : _errors.default.general
      });
    });
  }
  componentDidMount() {
    if (!window.zxcvbn) {
      (0, _addScript.default)(ZXCVBN_URL);
    }
  }
  render() {
    const {
      email,
      emailSuggestion,
      onEmailCorrection,
      onEmailChange,
      onBack
    } = this.props;
    const {
      password,
      isCreatingAccount,
      error,
      passwordStrength,
      validateEmail,
      showPasswordHint
    } = this.state;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CreateAccount.default, {
      email: email,
      password: password,
      error: error == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          ...error,
          values: {
            email
          }
        })
      }),
      emailError: validateEmail ? validators.email(email) : null,
      emailSuggestion: emailSuggestion,
      passwordStrength: passwordStrength,
      passwordError: showPasswordHint ? validators.password(password) : null,
      isLoading: isCreatingAccount,
      showPasswordHint: showPasswordHint,
      onBack: onBack,
      onEmailChange: onEmailChange,
      onEmailCorrection: onEmailCorrection,
      onEmailBlur: this.handleEmailBlur,
      onPasswordChange: this.handlePasswordChange,
      onPasswordBlur: this.handlePasswordBlur,
      onContinue: this.handleContinue
    });
  }
}
const CreateAccountScreen = props => {
  const {
    log
  } = React.useContext(_context.default);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CreateAccountWithoutContext, {
    ...props,
    log: log
  });
};
var _default = exports.default = CreateAccountScreen;